import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { useCurrentUser } from '@/features/auth/use-auth';

export function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const location = useLocation();
  const token = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const meQuery = useCurrentUser();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (meQuery.isLoading && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Cargando sesion...
      </div>
    );
  }

  if (meQuery.isError || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
